<template>
    <div>
        <a-form-model :form="form" :model="formData" labelAlign="left">
            <a-skeleton :loading="preload" active>
                <a-descriptions bordered>
                    <a-descriptions-item label="Kompetensi" span="3">
                        <strong>{{ aspect }}</strong>
                    </a-descriptions-item>
                    <!-- -->
                    <a-descriptions-item label="Key Result Area" >
                        {{ info.obj.key_result}}
                    </a-descriptions-item>
                    <a-descriptions-item label="Sasaran" span="2">
                        {{ info.obj.name }}
                    </a-descriptions-item>
                    <!-- -->
                    <a-descriptions-item label="Bobot (%)">
                        <strong>{{ info.obj.weight }}%</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Scoring" span="2">
                        {{ scoringLabel[info.original.config.scoring] }}
                    </a-descriptions-item>
                    <!-- -->
                    <a-descriptions-item label="Ukuran" span="3">
                        {{ info.obj.target}}
                    </a-descriptions-item>
                    <!-- -->
                    <a-descriptions-item label="Measurement" span="3">
                        {{ info.original.config.measurement }}
                    </a-descriptions-item>
                    <!-- -->
                    <a-descriptions-item label="Periode" span="2">
                        <strong>{{ month.format('MMMM') }}</strong>
                    </a-descriptions-item>
                    <a-descriptions-item label="Tahun">
                        <strong>{{ month.format('YYYY') }}</strong>
                    </a-descriptions-item>
                    <!-- -->
                    <a-descriptions-item label="Target" span="3">
                        <strong>{{ number_format(info.obj.target_ongoing) }}</strong>
                    </a-descriptions-item>
                    <!-- -->
                    <a-descriptions-item label="Realisasi" span="2">
                        <a-input v-model="realization" :disabled="is_scoring || info.obj.achievement.status === 'approved'" v-if="!is_scoring"/>
                        <div v-else>{{ realization }}</div>
                    </a-descriptions-item>
                    <a-descriptions-item label="Realisasi">
                        <strong>{{ targetRealization }}</strong>
                    </a-descriptions-item>
                    <!-- -->
                    <a-descriptions-item label="Pencapaian Realisasi" :span="3">
                        <a-space>
                            <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" @change="handleChange" v-if="!is_scoring" accept="application/pdf">
                                <a-button><a-icon type="upload" /> Select File</a-button>
                            </a-upload>

                            <a-button v-if="info.obj.achievement.file_path" type="link" size="small" @click="download(info.obj.achievement.file_path)">
                                <a-icon type="file-pdf" theme="twoTone" two-tone-color="#3452eb" /> Download
                            </a-button>
                        </a-space>
                    </a-descriptions-item>

                    <!-- -->
                    <a-descriptions-item label="Keterangan" span="3">
                        <div v-if="!is_scoring && info.obj.achievement.status !== 'approved'">
                            <a-input v-model="formData.note" />
                        </div>
                        <div v-else>
                            {{ formData.note }}
                        </div>
                    </a-descriptions-item>

                    <!-- -->
                    <a-descriptions-item label="Rating" span="3" class="rating-box">
                        <a-radio-group v-model="formData.evaluation" style="font-weight: normal;" :disabled="true">
                            <a-radio :style="radioStyle" :value="opt.val" v-for="(opt, index) in womOptions" :key="index">
                                <strong>Rating {{ opt.val }}</strong> - {{ opt.label }}
                            </a-radio>
                        </a-radio-group>
                    </a-descriptions-item>

                    <template v-if="is_scoring && isAdvisor && !isEvaluator">
                        <!-- in scoring mode -->
                        <a-descriptions-item label="Evaluasi Kinerja" span="3">
                            <a-input v-model="formData.note_progress" :disabled="info.obj.achievement.status != 'approved'" />
                        </a-descriptions-item>
                        <!-- -->
                        <a-descriptions-item label="Saran dan Perbaikan" span="3">
                            <a-input v-model="formData.note_suggestion" :disabled="info.obj.achievement.status != 'approved'" />
                        </a-descriptions-item>
                        <!-- -->
                        <a-descriptions-item label="Evaluasi Laporan" span="3">
                            <a-input v-model="formData.note_report" :disabled="info.obj.achievement.status != 'approved'" />
                        </a-descriptions-item>
                        <!-- -->
                    </template>

                    <a-descriptions-item label="Approval" span="3" v-else-if="is_scoring && !isEvaluator">
                        <div v-if="info.obj.achievement.status == 'approved'">
                            APPROVED
                        </div>
                        <a-radio-group v-model="formData.approved" v-else>
                            <a-radio :value="false">
                            Review
                            </a-radio>
                            <a-radio :value="true">
                            Approve
                            </a-radio>
                        </a-radio-group>
                    </a-descriptions-item>

                    <a-descriptions-item label="Status" span="3" v-if="is_scoring && isAdvisor">
                        <div v-if="info.obj.achievement.status == 'approved'">
                            APPROVED
                        </div>
                    </a-descriptions-item>

                    <!-- -->
                    <a-descriptions-item label="Catatan Mentor" span="3" v-if="formData.approved == false">
                        <div v-if="is_scoring && info.obj.achievement.status !== 'approved' && !isAdvisor && !isEvaluator">
                            <a-input v-model="formData.mentor_note" />
                        </div>
                        <div v-else>
                            {{ formData.mentor_note }}
                        </div>
                    </a-descriptions-item>

                    <!-- -->
                    <a-descriptions-item label="Action" span="3" v-if="!isAdvisor && info.obj.achievement.status !== 'approved'">
                        <div class="text-right" v-if="!isEvaluator">
                            <a-button type="primary" html-type="submit" :loading="processing" :disabled="processing"
                            @click="showConfirm">{{ txtButton }}</a-button>
                        </div>
                    </a-descriptions-item>
                    <a-descriptions-item label="Action" span="3" v-if="isAdvisor && info.obj.achievement.status === 'approved'">
                        <div class="text-right">
                            <a-button type="primary" html-type="submit" :loading="processing" :disabled="processing"
                            @click="showConfirm">{{ txtButton }}</a-button>
                        </div>
                    </a-descriptions-item>
                </a-descriptions>
            </a-skeleton>
        </a-form-model>
    </div>
</template>

<script>
const scoringLabel = {
    higher_better: 'Higher Is Better',
    lower_better: 'Lower Is Better',
    precision: 'Precision',
    faster_better: 'Faster Is Better',
    slower_better: 'Slower Is Better'
}
export default {
    props: {
        info: {
            type: Object,
            required: true,
        },
        aspect: {
            type: String,
            required: true,
        },
        month: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        is_scoring: {
            type: Boolean,
            default: false
        },
        user_hash: {
            type: String,
            default: null
        }
    },
    computed: {
        womOptions() {
            let collection = []
            let ratings = this.info.original.config.wom.ratings

            if (ratings !== 'undefined') {
                Object.entries(this.info.original.config.wom.labels).forEach(function ([key, item]) {
                    collection.push({
                        key,
                        label: item,
                        val: ratings[key]
                    })
                })
            }

            return collection
        },
        targetRealization() {
            let real=0, type = this.info.original.config.breakdown_type, range = this.info.original.config.rating_range, k = null

            switch(type) {
                case 'fixed':
                    real = this.formData.realization || parseInt(this.formData.realization) || 0
                    break;
                case 'pro_rated':
                default:
                    if (this.formData.realization > 0 && this.formData.realization !== '') {
                        real = Math.round((this.formData.realization / this.info.obj.target_ongoing) * 100)
                    }
                    break;
            }
            k = _.findKey(range, function(i) {
                if (_.isArray(i)) {
                    return real >= parseFloat(i[0]) && real <= parseFloat(i[1])
                }

                return real == parseInt(i)
            })

            this.formData.evaluation = this.ratings[k] || 0

            return real.toString() + (type !== 'fixed' ? '%' : '')
        },
        editing() {
            return this.info.obj.achievement.hasOwnProperty('hash')
        },
        isAdvisor() {
            return this.$laravel.roles.performance === "advisor"
        },
        isEvaluator() {
            return this.$laravel.roles.performance === "evaluator"
        },
        txtButton(){
            if(this.isAdvisor){
                return 'Submit'
            }
            return this.formData.approved === true ? 'Approve' : 'Submit'
        }
    },
    data() {
        return {
            ratings: {'_1': 1, '_2': 2, '_3': 3, '_4': 4, '_5': 5},
            scoringLabel,
            labelCol: { span: 5 },
            wrapperCol: { span: 10 },
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
            },
            label: 2,
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            realization: this.info.obj.target_yield,
            fileList: [],
            formData: {
                objective_id: this.info.obj.id,
                period: this.month.format('YYYYMM'),
                note: null,
                mentor_note: null,
                note_progress: this.info.obj.achievement.note_progress ?? null,
                note_suggestion: this.info.obj.achievement.note_suggestion ?? null,
                note_report: this.info.obj.achievement.note_report ?? null,
                approved: this.info.obj.achievement.status === 'approved',
                evaluation: this.info.obj.achievement.evaluation ?? 0,
                target_monthly: this.info.obj.target_monthly,
                target_ongoing: this.info.obj.target_ongoing,
                realization: this.info.obj.target_yield,
                total_target: this.info.obj.total_target,
                total_yield: this.info.obj.total_yield,
            }
        }
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault(e);
            this.processing = true;
            let promise;
            let data = new FormData();

            if(this.fileList.length > 0){
                data.append("attachment", this.fileList[0]);                
            }

            if(this.info.obj.achievement.file_path != null){
                data.append("is_new", 0)
            }else{
                data.append("is_new", 1)
            }

            data.append("objective", this.info.original.hash)
            data.append("period", this.formData.period)
            data.append("target_yield", this.formData.realization)
            data.append("note", this.formData.note)
            data.append("mentor_note", this.formData.mentor_note)
            data.append("evaluation", this.formData.evaluation)
            data.append("approved", this.formData.approved ? '1' : '0')
            data.append("note_progress", this.formData.note_progress)
            data.append("note_suggestion", this.formData.note_suggestion)
            data.append("note_report", this.formData.note_report)
            data.append("is_scoring", this.is_scoring ? '1' : '0')

            if (this.user_hash !== null) {
                data.append("user", this.user_hash)
            }

            promise = this.$http.post(
                this.routeUri("api.performance.achievement.create"),
                data
            );

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            let successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            setTimeout(() => this.$emit("handleClose", true), 1000)
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();

            newFileList.splice(index, 1);

            this.fileList = newFileList;
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file];

            return false;
        },
        handleChange(info) {
            let fileList = [...info.fileList];

            if (fileList.length > 1) {
                fileList = [info.file];
                
                this.fileList = fileList;
            }
        },
        download(url) {
            window.open(window.location.origin + url, '_blank')
        },
        showConfirm(e) {
            this.$confirm({
                title: 'Konfirmasi',
                content: 'Anda yakin?',
                onOk: () => {
                    this.handleSubmit(e)
                },
                onCancel() {},
            })
        },
        getInitialStatus() {

        }
    },
    watch: {
        'info.obj.achievement': {
            immediate: true,
            deep: false,
            handler: function(item) {
                if(this.editing){
                    this.formData.note = item.note
                    this.formData.mentor_note = item.mentor_note
                }
            }
        },
        'realization': {
            immediate: true,
            deep: false,
            handler: function(item) {
                this.formData.realization = item.toString().replace(/\./g, "")
                this.realization = item.toString().replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            }
        },
        'formData': {
            immediate: true,
            deep: true,
            handler: function(item) {
                if(this.formData.note_progress === "null")
                    this.formData.note_progress = ""
                if(this.formData.note_suggestion === "null")
                    this.formData.note_suggestion = ""
                if(this.formData.note_report === "null")
                    this.formData.note_report = ""
                if(this.formData.note === "null")
                    this.formData.note = ""
                if(this.formData.mentor_note === "null")
                    this.formData.mentor_note = ""
            }
        },
    }
}
</script>
